import { render, staticRenderFns } from "./NotificationMessage.vue?vue&type=template&id=7f96e304&"
import script from "./NotificationMessage.vue?vue&type=script&lang=ts&"
export * from "./NotificationMessage.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationMessage.vue?vue&type=style&index=0&id=7f96e304&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports